import { FC } from 'react';
import AddEditDocument from 'src/views/components/addEditDocument/addEditDocument';
import {
  useStaffDocumentsActions,
  useStaffDocumentsState,
} from '../../contexts/staffDocuments.context';
import { useStaffService } from 'src/apis/staff/useStaffService';
import { useStaffState } from '../../contexts/staff.context';
import { TDocument } from 'src/apis/documents/documents.interfaces';

const StaffManageDocumentView: FC = () => {
  const {
    staffDocumentsAppState: {
      isManageDocumentOpen,
      selectedDocument,
      isDocumentLoading,
      documentErrorMessage,
    },
  } = useStaffDocumentsState();
  const {
    setIsManageDocumentOpen,
    setSelectedDocument,
    setIsDocumentLoading,
    setDocumentErrorMessage,
  } = useStaffDocumentsActions();
  const { postStaffDocument, patchStaffDocument } = useStaffService();
  const { selectedStaffId } = useStaffState();

  const handleClose = () => {
    setIsManageDocumentOpen(false);
    setSelectedDocument(null);
    setIsDocumentLoading(false);
    setDocumentErrorMessage('');
  };

  const onUploadProgress = (status: boolean, message: string) => {
    setIsDocumentLoading(status);
    setDocumentErrorMessage(message);
  };

  const handleSubmit = async (document: TDocument) => {
    try {
      const documentWithUserId = {
        ...document,
        userId: selectedStaffId || document.userId,
      };

      if (selectedDocument) {
        await patchStaffDocument(documentWithUserId);
      } else {
        await postStaffDocument(documentWithUserId);
      }
      handleClose();
    } catch (error: any) {
      setDocumentErrorMessage(
        error?.message || 'An error occurred while saving the document'
      );
    }
  };

  return (
    <div data-testid="staff-manage-document-container">
      <AddEditDocument
        isOpen={isManageDocumentOpen}
        onClose={handleClose}
        onSubmit={handleSubmit}
        onUploadProgress={onUploadProgress}
        document={selectedDocument}
        isLoading={isDocumentLoading}
        errorMessage={documentErrorMessage}
      />
    </div>
  );
};

export default StaffManageDocumentView;
